/**
 * Internal Dependencies
 */
import Icon from './icon';

const blockAdminSettings = {
	color: '#6C5CE7',
	icon: Icon,
	title: 'Email',
	order: 1,
};

export default blockAdminSettings;
